// extracted by mini-css-extract-plugin
export var numpadContainer = "_rm-1";
export var phoneButton = "_rm-0";